"use client";
import {
    // ICM_MAIL,
    ICM_MAIL_SUPPORT,
    // ICM_REFER_AMAZON_BENEFIT,
    ICM_REFER_BENEFIT,
    // ICM_REFERRER_AMAZON_BENEFIT,
    // ICM_REFERRER_BENEFIT,
} from "@/app/utils/constants";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import React from "react";

const termsBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Terms & Conditions" },
];

const TermsAndConditions = () => {
    return (
        <section
            id="main-section"
            className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:px-36 md:pb-[120px] md:pt-0"
        >
            <Breadcrumb paths={termsBreadcrumbPaths} />
            {/* Pre IPO Offer */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Pre IPO | Unlisted Shares User offer: ₹200 Amazon Voucher and{" "}
                    {ICM_REFER_BENEFIT}% offer benefit on 1st successful transaction – Terms and
                    Conditions
                </h3>

                <p className="mb-4 text-lg font-semibold text-black">User Benefits:</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: This offer is valid for both New and Existing users who
                            have signed up on InCred Money. This is applicable for users signing up
                            on the InCred Money Pre IPO | Unlisted Shares platform.
                        </li>
                        <li className="mb-1">
                            Offer benefit of ₹200 Amazon Voucher and {ICM_REFER_BENEFIT}% offer
                            benefit transaction is applicable only for 1st transaction.
                        </li>
                        <li className="mb-1">
                            Product Type: Offer is applicable on Pre IPO | Unlisted Shares only.
                        </li>
                        <li className="mb-1">
                            Minimum requirement: It is applicable even on purchase of just 1 share.
                        </li>
                        <li className="mb-1">
                            Benefits: Upon meeting the eligibility criteria and successfully
                            purchasing Unlisted Shares, you will receive a ₹
                            {ICM_REFER_AMAZON_BENEFIT} Amazon gift voucher on your registered email
                            ID. Amazon vouchers issued will carry 6-7 year validity from the date of
                            issue.
                        </li>
                    </ul>
                </div>

                <p className="mb-4 text-lg font-semibold text-black">Referrer Benefits:</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Referrer will earn referral benefit for every new referral.
                        </li>
                        <li className="mb-1">
                            Referrer will receive ₹{ICM_REFERRER_AMAZON_BENEFIT} Amazon Voucher and{" "}
                            {ICM_REFERRER_BENEFIT}% offer benefit on 1st successful transaction by
                            his/her referral in Pre - IPO || Unlisted Shares
                        </li>
                        <li className="mb-1">
                            Referrer will receive <s>0.25%</s> {ICM_REFERRER_BENEFIT}% transaction
                            benefit from 2nd successful transaction onwards completed by his/her
                            referral in Pre - IPO || Unlisted Shares.
                        </li>
                        <li className="mb-1">
                            Referrer will receive a maximum of ₹10,000 per referral.
                        </li>
                        <li className="mb-1">Referrer can refer any number of referrals.</li>
                        <li className="mb-1">
                            The minimum transaction amount for the referee to avail this offer is
                            ₹1,000.
                        </li>
                        <li className="mb-1">
                            ETA Fintech Private Limited reserves the right at any time, without
                            prior notice and without assigning any reason whatsoever to
                            add/modify/alter/change and/or withdraw this offer at any time at its
                            sole discretion.
                        </li>
                        <li className="mb-1">
                            Customer unequivocally and irrevocably agrees that in case of any
                            dispute, the decision of ETA Fintech Private Limited will be final and
                            binding.
                        </li>
                    </ul>
                </div>

                <div id="Influencers-Affiliates" className="">
                    <p className="mb-1 text-lg font-semibold text-black">
                        Content Guidelines for Influencers & Affiliates: Unlisted Shares by InCred
                        Money
                    </p>
                    <p className="mb-4 text-lg font-semibold text-black">
                        (For Social Media, Blogs, Videos, and Other Public Platforms)
                    </p>
                    <p className="mb-4 text-base text-black">
                        When creating content related to unlisted shares, it is crucial to maintain
                        transparency, accuracy, and regulatory compliance. The following rules are
                        non-negotiable and are designed to protect retail investors, safeguard the
                        brand, and ensure legal compliance.
                    </p>
                    <div className="mb-8 text-base">
                        <ul className="mb-4 ml-4 list-decimal">
                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Avoid Misleading Investment Promises
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not guarantee returns or use terms like &quot;high
                                            growth&quot; potential, &quot;multibagger,&quot;
                                            &quot;guaranteed returns,&quot; or &quot;risk-free
                                            investment.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Avoid hype-driven phrases such as &quot;next big
                                            thing,&quot; &quot;once-in-a-lifetime opportunity,&quot;
                                            or &quot;sure shot.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Do not compare unlisted shares to listed stocks unless
                                            clearly stating differences in risk, volatility, and
                                            liquidity.
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Maintain Transparency on Risks & Performance
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Avoid making forward-looking statements about IPO
                                            timelines, price appreciation, or exit opportunities.
                                        </li>
                                        <li className="mb-1">
                                            Clearly state that unlisted shares are illiquid and
                                            subject to higher risk, and investors should do their
                                            own due diligence.
                                        </li>
                                        <li className="mb-1">
                                            If citing past returns, add a disclaimer: &quot;Past
                                            performance is not indicative of future outcomes.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Present a balanced narrative—highlight both
                                            opportunities and challenges.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Regulatory & Compliance Guidelines
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not imply or falsely claim SEBI/NSE/BSE approvals or
                                            suggest regulatory endorsement.
                                        </li>
                                        <li className="mb-1">
                                            If mentioning a potential IPO, add: &quot;IPO is not
                                            guaranteed, and timelines may change.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Never promote unlisted shares as substitutes for
                                            regulated financial instruments like mutual funds,
                                            insurance, or fixed deposits.
                                        </li>
                                        <li className="mb-1">
                                            Affiliates must comply with advertising, consumer
                                            protection, and data privacy laws.
                                        </li>
                                        <li className="mb-1">
                                            All content creators are legally liable for the claims
                                            made in their content.
                                        </li>
                                        <li className="mb-1">
                                            The company reserves the right to remove or report any
                                            content that violates these terms and terminate the
                                            partnership immediately.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Responsible Content & Data Accuracy
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not use fake reviews, unverified testimonials, or
                                            misleading headlines.
                                        </li>
                                        <li className="mb-1">
                                            Always cite sources for numbers, valuations, or
                                            claims—acceptable sources include annual reports,
                                            company filings, SEBI disclosures, and reputable media.
                                        </li>
                                        <li className="mb-1">
                                            Avoid cherry-picking data or projecting unlisted share
                                            valuations without context.
                                        </li>
                                        <li className="mb-1">
                                            Do not use terms like &quot;market cap&quot; or
                                            &quot;valuation&quot; unless based on disclosed,
                                            credible documentation.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Mandatory Disclaimers & Financial Responsibility
                                </p>
                                <p className="mb-2 ml-1 text-black">
                                    All content must include the following disclaimer:
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            &quot;This communication is for informational purposes
                                            only and does not constitute investment advice or a
                                            recommendation. Investments in unlisted shares are
                                            subject to market risks. Please consult a
                                            SEBI-registered advisor before investing.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Do not make buy/sell recommendations unless you are a
                                            registered investment advisor, and in such cases, ensure
                                            proper disclosures and risk warnings.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Brand Usage, Platforms & Approval
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not use the InCred Money name, logo, or brand
                                            identity without prior written approval.
                                        </li>
                                        <li className="mb-1">
                                            Do not create paid promotions, paid influencer posts, or
                                            sponsored ads using our name or unlisted share names
                                            without formal review and sign-off.
                                        </li>
                                        <li className="mb-1">
                                            All content (posts, videos, blogs, scripts) must be
                                            submitted to the company for review and approval before
                                            publishing.
                                        </li>
                                        <li className="mb-1">
                                            Do not use high-pressure tactics like &quot;only a few
                                            slots left&quot; or &quot;last chance&quot; unless
                                            explicitly provided by the company.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Legal Safeguards & Monitoring
                                </p>
                                <p className="mb-2 ml-1 text-black">
                                    The company will periodically monitor affiliate and influencer
                                    content for compliance. Any violations may lead to:
                                </p>
                                <div className="mb-4 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Immediate termination of the partnership
                                        </li>
                                        <li className="mb-1">
                                            Reporting to regulators or legal action
                                        </li>
                                        <li className="mb-1">
                                            Blacklisting from future collaborations
                                        </li>
                                    </ul>
                                </div>
                                <p className="-ml-3 mb-4 text-black">
                                    Affiliates are advised to retain content history for audit and
                                    compliance purposes for a minimum of 6 months.
                                </p>
                            </li>

                            <li className="mb-1 list-none">
                                <p className="-ml-3 mb-2 text-black">
                                    ✅&nbsp;&nbsp;Company&rsquo;s Right to Determine Compliance
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            The company reserves the sole right to determine whether
                                            any content, claim, or representation violates any
                                            guidelines, regulatory expectations, or brand standards.
                                        </li>
                                        <li className="mb-1">
                                            Any content found to be non-compliant, misleading, or
                                            reputationally risky—at the company&rsquo;s
                                            discretion—must be removed or revised upon request.
                                        </li>
                                        <li className="mb-1">
                                            Failure to comply with such requests may result in
                                            immediate termination and further legal action, if
                                            necessary.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1 list-none">
                                <p className="-ml-3 mb-2 text-black">
                                    ✅&nbsp;&nbsp;Your Responsibility
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            By engaging in content creation or affiliate activity
                                            with us, you acknowledge and agree to follow these
                                            guidelines in full.
                                        </li>
                                        <li className="mb-1">
                                            Violations, whether intentional or accidental, will have
                                            legal and reputational consequences.
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms and Conditions for Liquidation Program
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            We strongly advise investors not to approach Unlisted Shares with a
                            trading mindset or the expectation of short-term exits.
                        </li>
                        <li className="mb-1">
                            These investments are best suited for those with a long-term horizon.
                            Unlisted shares typically have limited liquidity, especially for smaller
                            quantities. Finding a buyer and executing a transfer can be
                            operationally challenging. Events such as an IPO are often the more
                            natural exit routes for such investments. Do note that your investment
                            would be locked in for 6 months from the date of the IPO.
                        </li>
                        <li className="mb-1">
                            That said, we understand that exceptional or unforeseen circumstances
                            may arise where you need to liquidate your holdings earlier. If you wish
                            to explore a sale, you can write to us at{" "}
                            <a href={"mailto:" + ICM_MAIL} className="text-blue-500 underline">
                                {ICM_MAIL}
                            </a>{" "}
                            with the following details:
                        </li>
                        <li className="mb-1">
                            Full Name:
                            <br />
                            Registered Email ID (with InCred Money)
                            <br />
                            PAN Number
                            <br />
                            Name of the Company <br />
                            Quantity of Shares to Sell <br />
                        </li>
                        <li className="mb-1">
                            Once we receive your request, our team will get in touch and attempt to
                            find a buyer on a best-effort basis. If we are successful, we’ll quote
                            you a price for your shares.
                        </li>
                    </ul>
                    <p className="mb-4 text-lg font-semibold text-black">
                        <span className="text-black">A few important points to keep in mind:</span>
                    </p>
                    <div className="mb-8 text-base text-neutral-500">
                        <ul className="mb-4 ml-6 list-disc">
                            <li className="mb-1">
                                The quoted price may be up to ~5–7% lower than the current platform
                                price, depending on demand and quantity.
                            </li>
                            <li className="mb-1">
                                For some stocks with very low demand, we may not be able to
                                facilitate a buyback.
                            </li>
                            <li className="mb-1">
                                You are always free to find your own buyer outside of our platform
                                as well.
                            </li>
                            <li className="mb-1">
                                There is a high probability that we may not be able to offer this
                                service for value less than ₹5,000.
                            </li>
                            <li className="mb-1">
                                The total transfer process may take upto 1 month from the request
                                being initiated
                            </li>
                        </ul>
                    </div>
                    <div className="mb-8 text-base text-neutral-500">
                        <ul className="mb-4 ml-6 list-disc">
                            <li className="mb-1">
                                <span className="text-black">
                                    If you agree to the quoted price, here&apos;s how the process
                                    works:
                                </span>
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Deal Sheet:</span> We will send you a
                                document with all transaction details.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Transfer of Shares:</span> You’ll need
                                to transfer the shares from your demat account to ours. Our team
                                will guide you through this step.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Fund Transfer:</span> Once we receive
                                the shares, we’ll confirm the receipt and transfer the funds to your
                                registered bank account.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">⚠️ Please Note:</span> If we receive
                                the shares after the price validity period, and there has been a
                                significant change in the stock price, the original offer may be
                                revised.
                            </li>
                        </ul>
                    </div>
                </div>
            </div> */}

            {/* FD New User Offer */}
            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    FD New User Offer: ₹250 Amazon Voucher - Terms and Conditions
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: New user: This offer is only valid for users who have
                            signed up on InCred Money on or after 13th March 2024. This is
                            applicable for users signing up on the InCred Money FD platform only.
                        </li>
                        <li className="mb-1">
                            FD Type: Offer is applicable on bank FD only. This offer is not
                            applicable on NBFC/Corporate FD due to regulatory restrictions.
                        </li>
                        <li className="mb-1">
                            Minimum deposit amount: It is applicable for minimum deposit amount of
                            ₹5,000 and minimum tenure of 1 year.
                        </li>
                        <li className="mb-1">
                            Benefits: Upon meeting the eligibility criteria and successfully opening
                            a Bank FD, you will receive a ₹250 Amazon gift voucher on your
                            registered email ID. Only 60 days of booking an FD, provided there is no
                            premature withdrawal of the FD before that. Amazon vouchers issued will
                            carry a 1 year validity from the date of issue.
                        </li>
                        <li className="mb-1">
                            Only users who book their first Fixed Deposit and complete Video KYC for
                            the same on the InCred Money App will be eligible for the offer.
                        </li>
                        <li className="mb-1">Maximum benefit per user will not exceed Rs. 250.</li>
                        <li className="mb-1">A user will only get the voucher once.</li>
                        <li className="mb-1">
                            Offer is valid only for - Utkarsh Small Finance Bank, South Indian Bank,
                            slice small finance bank.
                        </li>
                        <li className="mb-1">
                            ETA Fintech Private Limited reserves the right at any time, without
                            prior notice and without assigning any reason whatsoever to
                            add/modify/alter/change and/or withdraw this offer at any time at its
                            sole discretion.
                        </li>
                        <li className="mb-1">
                            Customer unequivocally and irrevocably agrees that in case of any
                            dispute, the decision of ETA Fintech Private Limited will be final and
                            binding.
                        </li>
                        <li className="mb-1">
                            This offer is not applicable for users who already have an account with
                            the bank with which the FD is opened.
                        </li>
                    </ul>
                </div>
            </div>

            {/* InCred Money Pro */}
            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl">
                    InCred Money Pro - Terms and Conditions
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: New user: This offer is applicable for users who make a
                            cumulative deposit of FD sums in Fixed Deposits offered on InCred Money
                            (banks or NBFCs).
                        </li>
                        <li className="mb-1">
                            Benefits: Upon investing ₹5 lakhs in FD on InCred Money, you will be
                            upgraded to InCred Money pro within 1 working days. You will receive an
                            email communicating the same to you.
                        </li>
                        <li className="mb-1">
                            Terms & conditions for the membership program:
                            <ul className="ml-6 list-disc">
                                <li>Customer should be a registered Customer of InCred Money.</li>
                                <li>
                                    Customer should be of an age 18 years or above and of sound mind
                                    at the time of being a part of the contest & should have valid
                                    proof of identity and address.
                                </li>
                                <li>
                                    Employees of InCred Money, their immediate family members,
                                    InCred Money Affiliates, advisors, advertising/partner agencies
                                    are not eligible to enter the contest.
                                </li>
                                <li>
                                    Customer should be an individual legal resident of the Republic
                                    of India.
                                </li>
                                <li>
                                    Participation in the Offer is voluntary and free. Participation
                                    in the Offer will be construed as acceptance of the Terms &
                                    Conditions of the Offer and participant warrants that he/she is
                                    willing to be bound by the Terms & Conditions. By accepting the
                                    Terms & Conditions of this offer, Alpha Fintech Private Limited
                                    is not charging anything from the customer for their
                                    participation in the offer.
                                </li>
                                <li>
                                    The reward under no circumstances will be settled in Cash/cannot
                                    be transferred.
                                </li>
                                <li>
                                    This is an electronic record in terms of Information Technology
                                    Act, 2000, and the rules thereunder as applicable and the
                                    amended provisions pertaining to electronic records in various
                                    statutes as amended by the Information Technology Act, 2000.
                                    This electronic record is generated by a computer system and
                                    does not require any physical or digital signatures.
                                </li>
                                <li>
                                    Alpha Fintech Private Limited reserves the right at any time,
                                    without prior notice and without assigning any reason whatsoever
                                    to add/modify/alter/ change and/or withdraw this offer at any
                                    time at its sole discretion.
                                </li>
                                <li>
                                    Customer unequivocally and irrevocably agrees that in case of
                                    any dispute, the decision of Alpha Fintech Private Limited will
                                    be final and binding.
                                </li>
                                <li>
                                    The competent Court of Mumbai shall have the exclusive
                                    jurisdiction for any matter or dispute related to Alpha Fintech
                                    Private Limited.
                                </li>
                                <li>
                                    This offer/scheme shall be subjected to all applicable
                                    central/or state laws, rules and regulations
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>

            {/* General Terms */}
            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl">
                    Terms and Conditions for the Liquidation Program
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            &apos;Anytime Liquidity&apos; feature offers liquidity to investors only
                            after 21 days from their order processed date.
                        </li>

                        <li className="mb-1">
                            Cost of liquidity provided is 2% of the latest market to market price
                            per unit.
                        </li>
                    </ol>
                </div>
            </div>
            <div className="mb-12">
                <h3 className="tracking--0.48px mb-6 text-4xl font-semibold leading-10 md:text-6xl">
                    For Corporate Bonds
                </h3>
                <p className="mb-4 font-semibold">
                    Please follow the steps for Liquidating your Bond. If any step is pending, the
                    liquidation will remain incomplete:
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 1</span> - Enter the units that you want to
                    liquidate and click on &apos;Request Quote&apos;. You can liquidate any number
                    of units up to a maximum of the total free units available. You will now get an
                    OTP on your Mobile and Email. Input the OTP to confirm your request. Once
                    confirmed, your liquidation price will be finalized, and the liquidation price
                    will be frozen.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 2</span>- Once the redemption amount is
                    finalized, you will have to complete the transaction through your broker
                    platform which is linked to your DEMAT account. On the 3rd working day post
                    confirming the liquidation (T+3 basis), the investor will have to place a Sell
                    Order through their Broker at the liquidation price and units confirmed in the
                    earlier step.
                </p>
                <p className="mb-4 text-neutral-500">
                    This order will be accepted from our side and once the order is matched on the
                    Stock Exchange, the units will be debited from your DEMAT account. You will
                    receive the funds in your account as per stock exchange regulations.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Important Note</span>: The price of the bond and
                    the redemption amount will be frozen irrespective of whether the transaction in
                    Step 3 is conducted or not through the broker platform. If you have missed
                    concluding the transaction at the designated time, you can contact our Customer
                    Support team and we will arrange for the transaction to be concluded on another
                    date at the same price and redemption amount frozen earlier.
                </p>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px mb-6 text-4xl font-semibold leading-10 md:text-6xl">
                    For Market Linked Debentures
                </h3>
                <p className="mb-4 font-semibold">
                    Please follow the steps for Liquidating your MLD. If any step is pending, the
                    liquidation will remain incomplete:
                </p>
                {/* <ul className="ml-6 list-disc text-neutral-500"> */}
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 1</span> - Enter the units that you want to
                    liquidate and click on &apos;Request Quote&apos;. You can liquidate any number
                    of units up to a maximum of the total free units available. You will now get an
                    OTP on your Mobile and Email. Input the OTP to confirm your request. Once
                    confirmed, you will get a fresh quote for Liquidation.
                </p>{" "}
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 2</span> - You will receive a notification
                    once the fresh quote is ready, and you can complete the liquidation process by
                    logging in on the InCred Money platform. Navigate to &apos;My Recent
                    Transactions/Details&apos; on the asset that you are looking to liquidate. Click
                    on &apos;Quote Ready&apos; to check the fresh quote. You may accept the quote by
                    clicking on &apos;Liquidate Now&apos;. The quote will be confirmed based on
                    market movements. At this step, you are redirected to a new &apos;Liquidate
                    Now&apos; screen. This quote is visible on the landing/home screen, navigating
                    the &apos;Confirm Now&apos; button the quote will become invalid, and the
                    request will need to regenerate.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 3</span> - Once you click on &apos;Liquidate
                    Now&apos;, another OTP will be generated which you will receive on your Email
                    and Mobile. Once you input this OTP, Liquidation Screen will confirm the
                    liquidation price, the redemption amount will be finalized.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 4</span> - Once the redemption amount is
                    finalized, you will have to complete the transaction through your broker
                    platform which is linked to your DEMAT account. On the 3rd working day post
                    confirming the liquidation (T+3 basis), the investor will have to place a Sell
                    Order through their Broker at the liquidation price and units confirmed in the
                    earlier step.
                </p>
                <p className="mb-4 text-neutral-500">
                    This order will be accepted from our side and once the order is matched on the
                    Stock Exchange, the units will be debited from your DEMAT account. You will
                    receive the funds in your account as per stock exchange regulations.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Important Note</span>: The price of the MLD and the
                    redemption amount will be frozen irrespective of whether the transaction in Step
                    4 is conducted or not through the broker platform. If you have missed concluding
                    the transaction at the designated time, you can contact our Customer Support
                    team and we will arrange for the transaction to be concluded on another date at
                    the same price and redemption amount frozen earlier.
                </p>
                {/* </ul> */}
            </div>

            <div id="section-global-stocks" className="mb-12">
                <h4
                    id="subtitle-global-stocks"
                    className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]"
                >
                    Terms & Conditions –{" "}
                    <span className="">$5 Welcome Bonus on US Stock Investing</span>
                </h4>

                <p className="text-neutral-1000 mb-4 font-bold">Eligibility</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        This offer is valid only for{" "}
                        <strong>new, first-time InCred Money US Investing customers</strong>.
                    </li>
                    <li className="mt-4">
                        Open to Indian tax residents, aged 18 or above, eligible to invest under
                        RBI&apos;s Liberalised Remittance Scheme (LRS).
                    </li>
                    <li className="mt-4">
                        Full KYC (PAN, Aadhaar, etc.) must be completed successfully before the
                        bonus is credited.
                    </li>
                    <li className="mt-4">
                        Limited to <strong>one bonus per user</strong>, verified by unique PAN,
                        Aadhaar-linked mobile number, and bank account.
                    </li>
                    <li className="mt-4">
                        The deposit must be funded from the user&apos;s{" "}
                        <strong>own bank account</strong> under LRS. Third-party or pooled funding
                        is not permitted.
                    </li>
                </ul>

                <p className="text-neutral-1000 mb-4 mt-5 font-bold">Minimum Deposit</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        Users must deposit a minimum of <strong>$100</strong> (or INR equivalent)
                        into their US Stocks account using their own funds under LRS.
                    </li>
                </ul>

                <p className="text-neutral-1000 mb-4 mt-5 font-bold">Rewards</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        Eligible users will receive a <strong>$5 bonus</strong>, credited as
                        investable cash into their US Stocks account within{" "}
                        <strong>7 business days</strong> of the deposit being confirmed and settled.
                    </li>
                    <li className="mt-4">
                        The bonus can only be used to purchase eligible US stocks/ETFs and is{" "}
                        <strong>not transferable or withdrawable as cash</strong>.
                    </li>
                    <li className="mt-4">
                        Any gains or losses on the invested bonus belong to the user.
                    </li>
                </ul>

                <p className="text-neutral-1000 mb-4 mt-5 font-bold">Disqualification & Clawback</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        InCred Money reserves the right to withhold, reverse, or recover the bonus
                        (up to <strong>180 days</strong> after credit) and suspend accounts in cases
                        of multiple or linked accounts, fraudulent or false information, third-party
                        funding, bot/scripted sign-ups, reversed remittances, or breach of any term.
                    </li>
                    <li className="mt-4">
                        The bonus may be taxable; users are responsible for their own tax liability
                        and disclosures. TDS may apply where required.
                    </li>
                </ul>

                <p className="text-neutral-1000 mb-4 mt-5 font-bold">Modification & Termination</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        InCred Money reserves the right to modify, suspend, or terminate this offer
                        at any time without prior notice, subject to applicable IFSCA, SEBI, and RBI
                        guidelines.
                    </li>
                    <li className="mt-4">
                        Decisions on eligibility and fraud are at InCred Money&apos;s sole
                        discretion and are final.
                    </li>
                </ul>

                <p className="text-neutral-1000 mb-4 mt-5 font-bold">General</p>
                <ul className="ml-8 list-disc text-neutral-500">
                    <li className="mt-4">
                        By participating, users confirm the deposit complies with FEMA, RBI, and
                        their LRS limit, and agree to these terms and InCred Money&apos;s{" "}
                        <strong>general terms and conditions</strong>.
                    </li>
                </ul>
            </div>

            <div id="section-bullion" className="mb-12">
                <h3
                    id="title-bullion"
                    className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]"
                >
                    TERMS AND CONDITIONS OF DIGITAL GOLD AND SILVER
                </h3>
                <p id="subtitle-bullion" className="text-neutral-1000 mb-4">
                    TERMS AND CONDITIONS OF &lsquo;GOLD / SILVER ACCUMULATION PLAN&rsquo; or
                    &lsquo;GAP&rsquo;
                </p>
                <p id="description-bullion" className="mb-4 text-neutral-500">
                    These &quot;<strong>terms</strong>&quot; and &quot;Conditions of Use&quot;
                    (&quot;Terms&quot;) constitute an electronic record within the meaning of the
                    applicable laws. This electronic record is generated by a computer system and{" "}
                    <strong>does not require any physical or digital signatures</strong>. These
                    Terms shall be in addition to and not in derogation to any other terms as
                    stipulated from time to time. By transacting for GAP on the Platform, you are
                    agreeing to and accept these Terms and Conditions.
                </p>

                <ul className="ml-6 list-decimal text-neutral-500">
                    <li className="mt-4">
                        In these Terms, references to &quot;you&quot;, &quot;your&quot; or
                        &quot;Customer&quot; shall mean the counterparty who transacts using the
                        Partner Platform, being a natural person, buying Gold / Silver from
                        MMTC-PAMP, redeeming Gold / Silver in the form of redeemable products sold
                        by MMTC-PAMP, transfer by Customer(s) to other Customer(s), selling back
                        Gold / Silver to MMTC-PAMP and receiving other related services in relation
                        to GAP. &quot;Platform&quot; shall mean the platform (website, mobile apps,
                        others) owned and operated by MMTC PAMP that the Customer accesses for the
                        GAP transactions, including all contents, services and technology offered
                        through the Platform. &quot;Partner Platform&quot; shall mean, and include,
                        the platforms (website, mobile apps, others) owned and operated by third
                        party partners of MMTC-PAMP (&quot;Partner&quot; or &quot;GAP
                        Partner&quot;), that the Customer accesses for the GAP transactions,
                        including all contents, services and technology offered through the Partner
                        Platform. &quot;Service Providers&quot; mean independent third-party service
                        providers. References to the &quot;Seller&quot;, &quot;MMTC-PAMP&quot;,
                        &quot;we&quot;, &quot;us&quot; and &quot;our&quot; shall mean MMTC-PAMP
                        India Private Limited, the owner of the GAP offering and the entity that
                        will sell Gold / Silver. &quot;Transfer&quot; refers to a facility to
                        transfer Gold / Silver from Gold / Silver account of one Customer to Gold /
                        Silver account of another Customer(s).
                    </li>
                    <li className="mt-4">
                        Capacity to enter into these Terms
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                the Customer is of legal age and is under no legal disability or
                                incapacity as per applicable laws, to enter into, these Terms and
                                the transactions contemplated by it, and perform its obligations;
                                and b.
                            </li>
                            <li className="mt-4">the Customer is not insolvent.</li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        The Customer represents and warrants that these Terms constitute a legal,
                        valid and binding obligation of the Customer and that all orders to be
                        placed and transactions to be conducted under these Terms are lawful.
                    </li>
                    <li className="mt-4">
                        In executing and giving effect to these Terms, the Customer does not and
                        will not infringe any provision of any other document or agreement to which
                        the Customer is a party, nor any law or judgment / order binding upon it.
                    </li>
                    <li className="mt-4">
                        MMTC–PAMP, reserves the right to change these Terms at any time at its sole
                        discretion. Such changes will be effective when posted on the Partner
                        Platform and on the Platform, as the case maybe and shall be deemed to be
                        notified to the Customer accordingly. Notwithstanding anything contrary,
                        Customer shall be responsible for regularly reviewing the Terms, including
                        amendments thereto as may be posted on the Partner Platform and the
                        Platform, as the case maybe and shall be deemed to have accepted the amended
                        Terms by continuing the use of Partner Platform and/ or the Platform, as the
                        case maybe.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP shall be entitled to collect, store, use and share relevant
                        information and documents provided by the Customer on the Partner Platform
                        and the Platform, as the case maybe for KYC purposes and; other purposes as
                        permissible under applicable laws, however, in case of usage of information
                        for other purposes, MMTC-PAMP shall intimate the same to the Customer about
                        such usage of their data provided on the Partner Platform and/ or the
                        Platform, as the case maybe. Further, as and when required by MMTC-PAMP, the
                        Customer will be required to provide additional documents for fulfilling the
                        KYC requirements. You authorize MMTC-PAMP to make such enquiries as it may
                        feel necessary to satisfy itself about the validity of your identity. You
                        undertake to update us in case of change of your existing information
                        including but not limited to your address, phone number, mobile number,
                        email ID etc. or verification documents provided by you.
                    </li>
                    <li className="mt-4">
                        We reserve the right to deactivate your Gold / Silver account, in the event
                        you fail to provide KYC documents / information to MMTC-PAMP / Partner
                        within required timelines. The Gold / Silver account may be activated only
                        upon submission of relevant documents. The Customer shall ensure that all
                        information supplied to MMTC-PAMP / Partner by the Customer is, or at the
                        time it is supplied will be, accurate in all material respects and the
                        Customer will not omit or withhold any information which would make such
                        information inaccurate in any material respect. You shall be responsible for
                        the correctness of information provided by you to MMTC-PAMP / Partner from
                        time to time. MMTC-PAMP will not be responsible for the incorrectness of KYC
                        documents / information provided by you. If at any time MMTC-PAMP finds that
                        the KYC documents are incorrect or authenticity of such KYC is doubtful,
                        MMTC-PAMP may, at its sole option, deactivate or close your Gold / Silver
                        account. If you have reasons to believe that there is an error in the
                        information furnished to MMTC-PAMP / Partner, you shall immediately advise
                        MMTC-PAMP and Partner in writing and forthwith provide correct / updated
                        information. The Customer authorizes MMTC-PAMP to pass on / deliver all such
                        information and documents to any third person.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP reserve the right to indefinitely suspend or terminate or block
                        access to any Gold / Silver account on the Partner Platform and the
                        Platform, as the case maybe, with or without notice to you, in the event the
                        KYC documents / information are found to be incorrect or authenticity of the
                        documents / information is found to be doubtful. You hereby undertake to
                        indemnify and keep indemnified MMTC-PAMP against any and all losses, claims,
                        liabilities, costs etc. which arise out of or relating to your failure to
                        identify yourself and validate your account promptly and / or due to
                        incorrect KYC documents / information.
                    </li>
                    <li className="mt-4">
                        You can offer to buy Gold / Silver worth Rs. 1.00 (Rupee One Only) and above
                        incremental value thereof at the live purchase price of Gold / Silver of
                        999.9 purity displayed on the Partner Platform and the Platform, as the case
                        maybe. Where errors have occurred in the pricing of transactions displayed
                        on the Platform and/ or the Partner Platform to the Customer, MMTC-PAMP,
                        reserves the right to not be bound by such a quote or transaction. Due to
                        delayed transmission between the Customer and Partner, the price offered on
                        Partner Platform and/ or the Platform may have changed before an order from
                        the Customer is received by Partner and/ or MMTC-PAMP, as the case maybe.
                        MMTC-PAMP reserves the right to cancel or reverse the transaction whether
                        before or after transaction confirmation. MMTC-PAMP further reserves the
                        right to credit / debit Gold / Silver / Silver / Silver balance in your Gold
                        / Silver / Silver / Silver account on account of cancellation or reversal of
                        any transaction(s).
                    </li>
                    <li className="mt-4">
                        Payment will be accepted only through payment options made available on the
                        Platform and the Partner Platform, as the case maybe. At the time of
                        purchase / redemption / sale-back / Transfer of Gold / Silver, the relevant
                        taxes will be chargeable as applicable as per the Government regulations.
                        MMTC-PAMP will not be responsible for any wrong / erroneous credit / debit
                        from Customer&rsquo;s bank account / wallet and / or services provided by
                        the payment solution engaged in case of misinformation or wrong information
                        from GAP Partner. GAP Partner will not be responsible for any wrong /
                        erroneous credit / debit from Customer&rsquo;s bank account / wallet and/ or
                        services provided by the payment solution engaged in case of misinformation
                        or wrong information from the Customer. Before making any offer for purchase
                        of Gold / Silver, you understand and acknowledge that Issuance of Invoice at
                        the time of Purchase of Gold / Silver, only records making of an offer by
                        you for purchase of the quantity of Gold / Silver stated therein and does
                        not create any right, title or interest in the quantity of the Gold / Silver
                        stated therein and/or against MMTC-PAMP. The right, title and interest in
                        the quantity of Gold / Silver stated in the invoice will only accrue upon
                        acceptance of such offer by MMTC-PAMP and upon actual receipt of sale
                        consideration by MMTC-PAMP.
                    </li>
                    <li className="mt-4">
                        At the time of redemption, the Customer can select redeemable product for
                        redemption from catalogue of redeemable products. These redeemable products
                        will be hosted on the Partner Platform and the Platform, as the case maybe.
                        The list of redeemable products may be altered, changed and amended by
                        MMTC-PAMP from time to time at its sole discretion.
                    </li>
                    <li className="mt-4">
                        At the time of redemption in physical deliverable product form, the Customer
                        will pay additional manufacturing and delivery charges and applicable taxes
                        on the same. The redeemable product selected from the catalogue for delivery
                        shall be subject to availability of stock with the MMTC-PAMP. MMTC-PAMP
                        shall be responsible for the delivery of the product(s) to the Customer and
                        the GAP Partner shall not be liable for the same in any manner whatsoever
                        unless otherwise agreed between MMTC-PAMP and the Partner, separately.
                    </li>
                    <li className="mt-4">
                        For each confirmed purchase of Gold / Silver by the Customer, MMTC-PAMP will
                        be the custodian of the Gold / Silver, till such Gold / Silver is lying in
                        your Gold / Silver account subject to terms herein. The Gold / Silver
                        purchased by you will be allocated and stored in highly advanced and secured
                        vaults of MMTC-PAMP or such third-party vaults as authorized by MMTC-PAMP
                        across various locations for operational reasons in order to provide you
                        with services in an efficient manner, with full insurance cover.
                    </li>
                    <li className="mt-4">
                        The Customer will have the option of redeeming and asking for physical
                        delivery of the full or part of the accumulated Gold / Silver holding, in
                        the form of redeemable products starting from 1 (One) gm and above. The
                        residual fractional Gold / Silver remaining, upon redemption by you of the
                        entire Gold / Silver holding, can be sold back by you to us at the live
                        sell-back price of Gold / Silver of 999.9 purity and the corresponding
                        amount against the residual fractional Gold / Silver sold by you will be
                        credited to your designated bank account.
                    </li>
                    <li className="mt-4">
                        Once the redemption has been initiated by you and payment received then your
                        Gold / Silver grams will be debited accordingly from your Gold / Silver
                        account.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP may also, from time to time in future, offer / permit the Customer
                        to sell-back its Gold / Silver to MMTC-PAMP at prevailing live sell-back
                        price of Gold / Silver of 999.9 purity, during the offer period as may be
                        announced / permitted by MMTC-PAMP. The money against the Gold / Silver sold
                        by a Customer would be credited to the Customer&rsquo;s bank account as per
                        the details provided by the Customer.
                    </li>
                    <li className="mt-4">
                        Live purchase price of Gold / Silver will be displayed on the Partner
                        Platform and the Platform, as the case maybe and is subject to change from
                        time to time. At the time you make request for redemption / sell-back, the
                        value of Gold / Silver / quantity of Gold / Silver to be redeemed / sold
                        back will be displayed based on live sell-back price of Gold / Silver. The
                        live purchase price of Gold / Silver and live sell-back price of Gold /
                        Silver may vary and also may be different from that available in the open
                        market and / or in any other retail outlet. Your offer may be rejected due
                        to any issue with the transaction and money paid by you, if any, will be
                        refunded. In such an event if you still wish to offer to purchase Gold /
                        Silver or sell-back residual fractional Gold / Silver, you may make another
                        offer at the changed price. MMTC-PAMP and GAP Partner disclaims any and all
                        claims and / or liabilities arising from such non-acceptance of offer or
                        revision in prices.
                    </li>
                    <li className="mt-4">
                        While availing any of the payment method(s) available on the Partner
                        Platform and the Platform, as the case maybe, MMTC-PAMP and the GAP Partner
                        will not be responsible or assume any liability, whatsoever in respect of
                        any loss or damage arising directly or indirectly to the Customer due to:
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">Lack of authorization for any transaction(s);</li>
                            <li className="mt-4">
                                Exceeding the preset limit prescribed by MMTC-PAMP;
                            </li>
                            <li className="mt-4">
                                Illegitimacy of the payment methods (credit / debit card frauds
                                etc.) being used by a Customer;
                            </li>
                            <li className="mt-4">
                                Temporary discontinuation of invitation to offer or offer to sell
                                back;
                            </li>
                            <li className="mt-4">
                                Any unauthorized, inaccurate or fraudulent transactions and / or for
                                any chargeback transactions; and / or,
                            </li>
                            <li className="mt-4">
                                Decline of transaction for any reason(s) whatsoever.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP may, at its discretion, prescribe maximum individual / cumulative
                        limits for Customer(s) to accumulate Gold / Silver, purchase Gold / Silver,
                        redemption of Customer redeemable Gold / Silver, Transfer or sell back of
                        Gold / Silver or any other transaction under GAP from time to time and
                        reserves the right to refuse to accept order exceeding such limit. MMTC-PAMP
                        may at its discretion, prescribe maximum individual / cumulative transaction
                        limits on GAP from time to time, and reserves the right to refuse to accept
                        order exceeding such limit.
                    </li>
                    <li className="mt-4">
                        At any point of time on any day MMTC-PAMP may temporarily discontinue the
                        invitation to offer purchase of Gold / Silver under GAP for any reason
                        whatsoever.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP may, at its discretion, close down, suspend and / or migrate the
                        Gold / Silver account of Customer(s), if (a) the Custody Period has expired;
                        and / or (b) MMTC-PAMP decides to discontinue the GAP scheme and / or (c)
                        any other reason(s) as may be determined by MMTC-PAMP. In such event(s) the
                        Customer can redeem the Gold / Silver accumulated by him/her in his/her Gold
                        / Silver account, and take delivery of the redeemable products and sell back
                        to MMTC-PAMP the residual fractional Gold / Silver lying in his / her Gold /
                        Silver account at the live sell-back price of Gold / Silver. Further, if the
                        open sale back window is made available by MMTC-PAMP, then the Customer may
                        sell back the product in his/her Gold / Silver account in whole or in part.
                        The redemption and sell back by the Customer shall be as per terms
                        prescribed by MMTC-PAMP&rsquo;s in the notice given for exercising the right
                        to close, under this clause. For the purpose of this clause, ‘Custody
                        Period&rsquo; shall mean a period of 5 years from the date of last purchase
                        / receipt of Gold / Silver in the Gold / Silver account of the Customer. In
                        the event the Customer(s) fails, neglects or chooses not to redeem and / or
                        sell-back, as applicable, their Gold / Silver holdings within the time
                        prescribed, then MMTC-PAMP will be entitled to levy on Customer(s), custody
                        charges at the rate of up to 0.5% (zero-point five percent) per annum of the
                        value of the Gold / Silver balance of the Customer held in the custody of
                        MMTC-PAMP. The custody charges will be deducted from the Gold / Silver
                        balance of the Customer as per frequency determined by MMTC-PAMP. In the
                        event that MMTC-PAMP does not exercise its&rsquo; discretion to close down
                        the Gold / Silver account of Customer(s) in terms of this clause,
                        Customer(s) can continue their Gold / Silver account by paying the custody
                        charges as provided above.
                    </li>
                    <li className="mt-4">
                        The Customer will not be entitled to make an offer for delivery if the zip
                        code of delivery address is outside serviceable areas. At time of redemption
                        the Customer will be required to provide full delivery address. In the event
                        the Customer(s) chooses the delivery address outside the serviceable areas
                        or if the delivery address subsequently becomes unserviceable, then on being
                        notified, Customer may sale-back the Gold / Silver during the open sale back
                        window as per Terms herein. This is not applicable in case the delivery
                        services are being offered by the GAP Partners.
                    </li>
                    <li className="mt-4">
                        All redeemable products selected for delivery by Customer for redemption,
                        shall be delivered within India as per instructions of the Customer through
                        our logistics partners. All deliveries where applicable shall be made on a
                        best-efforts basis, and while MMTC-PAMP will endeavour to deliver the
                        products on the dates intimated, MMTC-PAMP disclaims any claims or
                        liabilities arising from any delay in this regard. Unless otherwise agreed
                        between MMTC-PAMP and the GAP Partner, the GAP Partner shall not be involved
                        in the delivery of the product to the Customer and shall not be held
                        accountable for it in any manner whatsoever.
                    </li>
                    <li className="mt-4">
                        Delivery by the logistics partners designated by MMTC-PAMP from time to time
                        shall be completed only after verification through an OTP (One-Time
                        Password) sent to the registered mobile number or such other verification /
                        authentication system that may be adopted by MMTC-PAMP from time to time for
                        delivery of Gold / Silver. In case the Customer wishes to change the mobile
                        number or address provided, a formal request shall be raised for the same
                        via Partner Platform or the Platform, as the case maybe. The logistics
                        partner of MMTC-PAMP will make a maximum of three attempts to deliver your
                        order. After three attempts Gold / Silver coin will be delivered back to
                        MMTC-PAMP and Customer will need to put the fresh request for the
                        redemption. This is not applicable in case the delivery services are being
                        offered by the GAP Partners.
                    </li>
                    <li className="mt-4">
                        In case Customer doesn&rsquo;t get the delivery due to any reasons
                        attributed to MMTC-PAMP or its delivery partner then the Customer will get
                        the refund of making and delivery charges.
                    </li>
                    <li className="mt-4">
                        In case delivery doesn&rsquo;t happen due to unavailability of the Customer
                        or any other reason attributed to the Customer then, MMTC-PAMP shall not be
                        liable for refund of making and delivery charges.
                    </li>
                    <li className="mt-4">
                        Any Customer disputes, grievances, complaints, queries or issues with
                        respect to the transaction including with respect to the quality and
                        merchantability, shall be directed to the Partner or MMTC-PAMP, as the case
                        maybe, by the Customer and will be subject to the Terms herein and addressed
                        as per the grievance redressal policies for the GAP products and services.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP shall not be liable to directly entertain any such disputes,
                        grievances, complaints, queries or issues.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP and Partner Platform shall not be liable / responsible, in any
                        manner whatsoever, for any loss / liability arising out of or relating to
                        any technical failure / issue in Partner Platform or the Platform, as the
                        case maybe, MMTC-PAMP shall not be liable / responsible, in any manner
                        whatsoever, for any loss / liability arising out of or relating to any
                        technical failure /and / or acts/ omission attributable to Partner and/or
                        Retailers, agents, employees, subcontractors, distributors etc
                        appointed/engaged by the Partner.
                    </li>
                    <li className="mt-4">
                        Notwithstanding anything contrary contained herein, the Customer
                        acknowledges that from time to time, and for any reason, the service, the
                        interface and API work, and their respective information, pricing and data,
                        and availability are subject at any time and from time to time to human,
                        mechanical , typographic, or other errors, oversights, mistakes,
                        limitations, delays, service interruptions, including, without limitation,
                        as may be due in whole or in part to, related to or arising out of (i)
                        computer hardware and software, telecommunication and operating systems,
                        databases, or business processes and procedures, (ii) other problems
                        inherent in, or which may be associated with, the use of the internet and
                        electronic communications including, without limitation, force majeure
                        event, government / regulatory actions, orders, notifications etc. and / or
                        and acts and omissions of third parties etc. affecting or impacting the
                        service, the interface or the API work, its information and data, or such
                        communications. Customer acknowledges and agrees that MMTC PAMP and the GAP
                        Partner are not responsible or liable whatsoever for delays, failures, or
                        other loss due to, caused by or resulting from any such problems, in whole
                        or in part. If your Gold / Silver account is over credited or wrongfully
                        credited / debited, then MMTC PAMP has right to reverse / cancel without
                        notice or require cancellation / reversal of such transaction at its sole
                        discretion and debit / credit the Gold / Silver to / from your Gold / Silver
                        account, as the case may be.
                    </li>
                    <li className="mt-4">
                        Upon MMTC-PAMP confirming the purchase, redemption, sale-back of Gold /
                        Silver in his / her Gold / Silver account by Customer, the order / request
                        of Customer to purchase / redemption / sale-back / Transfer of Gold /
                        Silver, as the case may be, shall be binding on the Customer and cannot be
                        cancelled.
                    </li>
                    <li className="mt-4">
                        The Customer shall inform immediately, in any case no later than 30 days of
                        the transaction, of any irregularities or discrepancies that may exist in
                        his / her Gold / Silver account, failing which it shall be deemed that there
                        is no error or discrepancies in the account. All records maintained by
                        MMTC-PAMP / Partner, in electronic or documentary form of the instructions
                        of the Customer and such other details (including, but not limited to
                        payments made or received) pursuant to the Terms, shall as against the
                        Customer, be deemed to be conclusive evidence of such instructions.
                    </li>
                    <li className="mt-4">
                        The Customer understands and acknowledges that any purchase, suspension of
                        sale of products, redemption, Transfer or sale-back from / to Gold / Silver
                        account / Transfer of Gold / Silver will be on instructions received by the
                        Customer, and the Customer will not violate any applicable laws or
                        regulations for the time being in force in or outside India. The Customer
                        shall be solely responsible for complying with applicable laws in respect of
                        purchase, suspension of sale of products, redemption, Transfer or sale-back
                        to and from the Gold / Silver account, Transfer of Gold / Silver including
                        but not limited to the Prevention of Money Laundering Act, 2002, the
                        Prohibitions of Benami Property Transactions Act, 1998, Income Tax Act, 1961
                        etc. including amendment thereof. Customer also agrees and undertakes that
                        he / she will not open any account in the name of any minor. MMTC-PAMP will
                        not be liable in any manner in this regard.
                    </li>
                    <li className="mt-4">
                        The Customer feedbacks pertaining to products shall be deemed to be
                        non-confidential and non-compensatory in nature. MMTC-PAMP reserves the
                        right, at its sole discretion to use such information and such use shall be
                        entirely unrestricted. The Customer hereby irrevocably authorizes MMTC-PAMP
                        to disclose, exchange, share or part with all the information relating to
                        the Customer&rsquo;s details and payment history information and all
                        information pertaining to Customer&rsquo;s GAP transaction and undertakes
                        not to hold MMTC-PAMP and / or / its affiliates and other group companies
                        and their agents liable for use of the aforesaid information. GAP Partner
                        shall not be held accountable for the actions undertaken by MMTC-PAMP
                        regarding the usage of information provided by the Customer.
                    </li>
                    <li className="mt-4">
                        In the event of termination / expiry of MMTC-PAMP&rsquo;s arrangement with
                        Partner, the Customer will be notified and the Customer will have the option
                        to either: (i) continue with its Gold / Silver account with MMTC PAMP; or
                        (ii) discontinue with its Gold / Silver account with MMTC-PAMP. If Customer
                        chooses to continue with the Gold / Silver account of the Customer, their
                        Gold / Silver account will be migrated in the manner notified by MMTC-PAMP
                        to the Customer and Customer agrees to provide such support and information
                        as may be required for the purpose of transition / migration. If Customer
                        chooses to discontinue with the Gold / Silver account of the Customer, then
                        the Customer shall have the option to redeem the entire product in his Gold
                        / Silver account and take delivery of redeemable product and sell-back
                        residual fractional Gold / Silver at the live sell-back price of Gold /
                        Silver. In case of open sale back window, may sell-back the entire product
                        in his/her Gold / Silver account, at the then prevailing live sell-back
                        price of Gold / Silver. In addition, MMTC-PAMP may notify the Customer on
                        other available similar options / plans on the Partner Platform, and the
                        Customer, may choose to avail of any of such options provided by MMTC-PAMP
                        by following simple steps notified in that regard. If the Customer fails to
                        redeem the product in the Gold / Silver account within the prescribed time,
                        MMTC-PAMP will be entitled to charge custody charges as per clause 20 of
                        these Terms. MMTC-PAMP and GAP Partner will not be liable for any loss,
                        claim, demand, liability etc. arising on account of termination / expiry of
                        MMTC-PAMP&rsquo;s arrangement with Partner.
                    </li>
                    <li className="mt-4">
                        MMTC-PAMP will not, at any time, and under any obligation, be required to
                        transfer physical Gold / Silver of Customers in its custody to any other
                        person / platform. However, given that such Gold / Silver of Customers is
                        not, at all times, segregated and identifiable for each Customer and such
                        Gold/ Silver is collocated along with MMTC-PAMP&rsquo;s own gold/ silver,
                        MMTC-PAMP shall have the right to use such Gold / Silver in a fungible
                        manner across locations such that it does not affect the quantity of the
                        Gold/ Silver owned by the Customer in the custody of MMTC-PAMP in any manner
                        whatsoever.
                    </li>
                    <li className="mt-4">
                        These Terms shall be governed by and interpreted and construed in accordance
                        with the laws of India. The courts in New Delhi shall have exclusive
                        jurisdiction in respect of any matters arising therefrom.
                    </li>
                    <li className="mt-4">
                        In the event any dispute arises out of or in connection with the Terms
                        herein vis-à-vis the Customer, including the validity hereof, the parties
                        hereto shall endeavour to settle such dispute amicably in the first
                        instance. The attempt to bring about an amicable settlement shall be treated
                        as having failed as soon as one of the parties hereto, after reasonable
                        attempts, which shall continue for not less than 15 (Fifteen) calendar days,
                        gives a notice to this effect, to the other party in writing.
                    </li>
                    <li className="mt-4">
                        <strong>Accounting Treatment:</strong> The accounting treatment of the Gold/
                        Silver purchased by the Customer and in the custody of MMTC-PAMP pursuant to
                        GAP may differ based on inventory methods, revenue recognition and other
                        factors in accordance with the applicable laws including, but not limited to
                        the Indian Accounting Standards.
                    </li>
                    <li className="mt-4">
                        <strong>Phishing:</strong> In the event that you receive an email falsely
                        claiming to be from MMTC-PAMP or another group entity, or requesting
                        personal data and / or sensitive personal data or information
                        (&quot;Phishing&quot;), you agree that you will not provide any information
                        or data in response and you will contact Partner&rsquo;s Customer Service
                        team without delay. MMTC-PAMP agrees that it will never ask you to provide
                        your password over email or telephone. Should you receive an email or
                        telephone call which you suspect is Phishing or you are unsure about, you
                        agree that you will report the phishing email or spoof site without delay in
                        order to protect yourself and fellow Customers. You understand that you
                        should not click any links from unusual emails or download any attachments
                        in order to access your Gold / Silver / Silver Account.
                    </li>
                    <li className="mt-4">
                        <strong>Fraudulent Activity:</strong> If MMTC-PAMP suspects that fraudulent
                        activity has taken place within your Gold / Silver account, in order to
                        protect you, you understand that we may temporarily freeze your Gold /
                        Silver account to prevent any further or continuing unauthorized activity.
                    </li>
                    <li className="mt-4">
                        <strong>Usage and Proprietary Rights:</strong> You agree that any
                        information or data relating to, processed or created in connection with,
                        content or operation of the GAP is confidential and proprietary to
                        MMTC-PAMP, and that you will refrain from disclosing such information to any
                        third party except where required by Applicable Law.
                    </li>
                    <li className="mt-4">
                        <strong>Customer representations and warranties:</strong>
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                The Customer is bound by the applicable GAP product laws, applicable
                                operating rules, customs, usages and practices.
                            </li>
                            <li className="mt-4">The Customer is not insolvent.</li>
                            <li className="mt-4">
                                MMTC-PAMP relies on representations and warranties made by the
                                Customer. These representations and warranties and those contained
                                elsewhere in these Terms, survive the entering into of these Terms
                                and are repeated in respect of each GAP product transaction. The
                                Customer warrants and agrees that any person who is in possession of
                                any password is authorized by the Customer, and the Customer
                                acknowledges that they will be responsible for any actions on their
                                account associated with the use of its password. The Customer agrees
                                to notify MMTC-PAMP immediately should the Customer become aware of
                                any unauthorized use, loss or theft of the Customer&rsquo;s,
                                username, password or account numbers; or inaccurate information
                                with respect to the content of statements including, cash balances,
                                open positions or transaction history.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        <strong>Risk Disclosures:</strong>
                        <br />
                        The Customer represents and warrants to MMTC-PAMP that:
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                they have received, read, understood and accepted the risk
                                disclosures provided herein in relation to the GAP products
                                contained herein;
                            </li>
                            <li className="mt-4">
                                the Customer acknowledges, recognizes and understands that
                                investment in GAP may involve a degree of risk and loss;
                            </li>
                            <li className="mt-4">
                                the Customer has read these Terms and understands that, UNLESS
                                SPECIFICALLY AGREED WITH MMTC-PAMP AND UNLESS A STATEMENT OF ADVICE
                                HAS BEEN PROVIDED, MMTC-PAMP has only provided general advice, and
                                the Customer has considered its objectives and financial situation
                                and has obtained appropriate independent advice prior to entering
                                into these Terms and has formed the opinion that dealing in the GAP
                                products is suitable for the Customer&rsquo;s needs and purposes;
                            </li>
                            <li className="mt-4">
                                The Customer acknowledges that neither MMTC-PAMP nor any associated
                                entity guarantees the performance of any given GAP product or
                                account nor that any GAP product or account will achieve a
                                particular rate of return;
                            </li>
                            <li className="mt-4">
                                The Customer further acknowledges that the Partner Platform and the
                                Platform is merely a technical platform facilitating the transaction
                                as contemplated herein, and nothing contained herein or on the
                                Partner Platform shall be considered as an advice or recommendation
                                of any kind. GAP Partner and MMTC-PAMP shall not be liable for any
                                loss or damage caused to the Customer in this regard.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        <strong>Customer acknowledgements:</strong>
                        <br />
                        The Customer acknowledges to MMTC-PAMP that:
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                He / she will not receive interest or other earnings on the Gold /
                                Silver held in the Gold / Silver account. The use of the Platform
                                and any services of MMTC-PAMP does not constitute a trading of, or
                                an exchange in, securities, investment contracts, or any document,
                                instrument, or writing commonly known as a &quot;security&quot;, at
                                law or otherwise;
                            </li>
                            <li className="mt-4">
                                Anything MMTC-PAMP is permitted to do in accordance with these Terms
                                may be done in its absolute discretion, and any opinion or view
                                required to be formed by MMTC-PAMP may be formed in its absolute
                                discretion;{" "}
                            </li>
                            <li className="mt-4">
                                The Customer&rsquo;s failure to observe any of the undertakings or
                                representations may result in civil or criminal liability, as well
                                as termination of the use of the MMTC-PAMP services;{" "}
                            </li>
                            <li className="mt-4">
                                The Customer is responsible for maintaining adequate security and
                                control of passwords and any other codes that you use to access the
                                services of MMTC-PAMP. The Customer agrees to accept full
                                responsibility for the use of the Partner Platform and the Platform,
                                as the case maybe, for any orders transmitted through the Partner
                                Platform and the Platform, as the case maybe, and for all
                                communications and the accuracy of all information sent via the
                                Partner Platform and the Platform, as the case maybe, using the
                                Customer&rsquo;s name, password or any other personal identification
                                means implemented to identify the Customer. MMTC-PAMP will not be
                                responsible for any loss or claim arising out of our relying on
                                instructions provided to us using your Password;{" "}
                            </li>
                            <li className="mt-4">
                                You agree to exercise safe security practices when accessing and
                                conducting electronic transactions. This includes signing out and
                                closing any online electronic transaction services once all
                                transactions have been completed regardless of your method of
                                accessing the Partner Platform and the Platform, as the case maybe;{" "}
                            </li>
                            <li className="mt-4">
                                You understand and acknowledge that Issuance of Invoice at the time
                                of Purchase of Gold / Silver, only records making of an offer by you
                                for purchase of the quantity of Gold / Silver stated therein and
                                does not create any right, title or interest in the quantity of the
                                Gold / Silver stated therein and/or against MMTC-PAMP. The right,
                                title and interest in the quantity of Gold / Silver stated in the
                                invoice will only accrue upon acceptance of such offer by MMTC-PAMP
                                and upon actual receipt of sale consideration by MMTC-PAMP;{" "}
                            </li>
                            <li className="mt-4">
                                You understand and acknowledge that MMTC-PAMP has NOT given any
                                right or authority to either PARTNER or any of its Retailers,
                                agents, employees, subcontractors, distributors etc. to make any
                                representation or assurance to you on behalf of MMTC-PAMP or any
                                other authority to act as an agent of MMTC-PAMP. MMTC-PAMP is
                                separate and independent entity from PARTNER and has no relationship
                                of any nature whatsoever with the Retailers, agents, employees,
                                subcontractors, distributors etc appointed/engaged by the PARTNER.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        <strong>Restricted Activities:</strong>
                        <br />
                        You agree that you will not:
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                Breach this Agreement or any other agreement or policy that you have
                                agreed to with MMTC-PAMP;
                            </li>
                            <li className="mt-4">
                                Violate any law, statute, ordinance, or regulation (for example,
                                those governing financial services, consumer protection, unfair
                                competition, anti-discrimination, anti-bribery and anti-corruption,
                                or false or misleading advertising);
                            </li>
                            <li className="mt-4">
                                Act in a manner that is defamatory, trade libelous, threatening, or
                                harassing;
                            </li>
                            <li className="mt-4">
                                Provide false, inaccurate, or misleading information;
                            </li>
                            <li className="mt-4">
                                Refuse to cooperate in an investigation or provide confirmation of
                                your identity or any information you provide to us;
                            </li>
                            <li className="mt-4">
                                Conduct your business or use the MMTC-PAMP services in a manner that
                                results in, or may result in, complaints, disputes, claims,
                                reversals, chargebacks, fees, penalties, and other liability to us,
                                Partner, other users, third parties, or you;
                            </li>
                            <li className="mt-4">
                                Take any action that imposes an unreasonable or disproportionately
                                large load on our infrastructure; facilitate any viruses, Trojan
                                horses, worms, or other computer programming routines that may
                                damage, detrimentally interfere with, surreptitiously intercept, or
                                expropriate any system, data, or information; use an anonymizing
                                proxy; use any robot, spider, other automatic device, or manual
                                process to monitor or copy our Website without our prior written
                                permission; or use any device, software, or routine to bypass our
                                robot exclusion headers, or interfere or attempt to interfere with
                                the Platform or the MMTC-PAMP services.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        <strong>Waiver:</strong> Any failure or delay by MMTC-PAMP and/or GAP
                        Partner to enforce or exercise any provision of these Terms, or any related
                        right, shall not constitute a waiver by MMTC-PAMP and/or GAP Partner of that
                        provision or right. The exercise of one or more of MMTC-PAMP&rsquo;s and/or
                        GAP Partner&rsquo;s rights hereunder shall not be a waiver of, or preclude
                        the exercise of, any rights or remedies available to MMTC-PAMP or GAP
                        Partner under these Terms or in law or at equity. Any waiver of any
                        provision shall only be effective if made in writing and executed by a duly
                        authorized officer of MMTC-PAMP or GAP Partner, as applicable.
                    </li>
                    <li className="mt-4">
                        <strong>Force Majeure:</strong> If performance under these Terms by
                        MMTC-PAMP and/or GAP Partner is prevented, restricted, delayed or interfered
                        with by reason of labour disputes, strikes, acts of God, floods, lightning,
                        severe weather, shortages of materials, rationing, inducement of any virus,
                        Trojan or other disruptive mechanisms, any event of hacking or illegal usage
                        of the Partner Platform or Platform, utility or communication failures,
                        earthquakes, war, revolution, acts of terrorism, civil commotion, acts of
                        public enemies, blockade, embargo or any law, order, proclamation,
                        regulation, ordinance, demand or requirement having legal effect of any
                        government or any judicial authority or representative of any such
                        government, or any other act whatsoever, whether similar or dissimilar to
                        those referred to in this clause, which are beyond the reasonable control of
                        the MMTC-PAMP and/or GAP Partner and could not have been prevented by
                        reasonable precautions then MMTC-PAMP and/or GAP Partner shall be excused
                        and discharged from such performance to the extent of and during the period
                        of such force majeure event, and such non-performance shall, in no manner
                        whosoever, amount to a breach by the MMTC-PAMP and/or GAP Partner of its
                        obligations herein.
                    </li>
                    <li className="mt-4">
                        <strong>Absence of relationship:</strong> You represent and warrant to
                        MMTC-PAMP and GAP Partner that you have sufficient experience and knowledge
                        to make informed decisions to purchase / redeem / sale-back Gold / Silver /
                        redeemable products / Transfer of Gold / Silver You acknowledge that you are
                        making all of your own decisions in connection with purchases or redemption
                        or sale-back and that you have not relied on any information made available
                        by MMTC-PAMP, and that MMTC-PAMP and/or GAP Partner is not making any
                        recommendation with respect to such purchases / redemption /sale-back of
                        Gold / Silver / redeemable products / Transfer of Gold / Silver. No
                        relationship other than seller-purchaser, including, without limitation, any
                        agent-principal relationship, any advisor-advisee relationship, any
                        employee-employer relationship, any franchisee-franchisor relationship, any
                        joint venture relationship or any partnership relationship, exists between
                        you and MMTC-PAMP and/or GAP Partner. No relationship other than service
                        provider- service recipient including, without limitation, any
                        agent-principal relationship, any advisor-advisee relationship, any
                        employee-employer relationship, any franchisee-franchisor relationship, any
                        joint venture relationship or any partnership relationship, exists between
                        you and Partner.
                    </li>
                    <li className="mt-4">
                        <strong>Electronic Order Risks:</strong> Order entry systems have been
                        designed to provide an efficient and dependable method for entering orders.
                        Commercial internet Service Providers are not 100% reliable and a failure by
                        one or more of these providers may affect internet-based order entry. You
                        acknowledge that the order entry system is an electronic mechanical system
                        and as such may be subject to failure beyond the control of MMTC-PAMP and/or
                        GAP Partner. Therefore, MMTC-PAMP and/or GAP Partner shall not be
                        responsible for errors, negligence, inability to execute orders, delays in
                        transmission, delivery or execution of order due to breakdown or failure of
                        transmission or communication facilities, or to any other cause beyond
                        MMTC-PAMP&rsquo;s and/or GAP Partner&rsquo;s control or anticipation. You
                        acknowledge that pricing or typographical errors may occur and that
                        therefore, in the event that a product is listed at an incorrect price or
                        with incorrect information due to an error in pricing or product
                        information, MMTC-PAMP reserves the right, at our sole discretion, to refuse
                        or cancel or reject any orders placed for the products. Furthermore,
                        MMTC-PAMP reserves the right to deny refuse or cancel or reject any orders
                        placed in case of market volatility and / or unusual circumstances or
                        conditions. This includes, without limitation, unexpected unavailability of
                        product / Gold / Silver.
                    </li>
                    <li className="mt-4">
                        <strong>Customer responsibility for taxes, tariffs and duties:</strong>
                        &nbsp;You acknowledge that you are solely responsible for all taxes, tariffs
                        and duties that may be incurred as a result of purchase / redemption of Gold
                        / Silver / redeemable products. MMTC-PAMP will only collect taxes, tariffs
                        and duties on transactions to the extent explicitly required by law. It is
                        your responsibility to be aware and properly address any taxes, tariffs and
                        duties to which you may be subject by any local, state and / or federal
                        governments. If you have any questions about taxes, tariffs and duties, you
                        should consult a tax or other professional about your unique circumstances.
                        MMTC-PAMP does not represent to provide advice or recommendations about your
                        specific taxes, tariffs and duties and any statements made by us are only
                        for the purpose of raising issues for you to discuss with your tax or other
                        professional.
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                Effecting transaction based on instructions received from Customers;
                            </li>
                            <li className="mt-4">
                                The instruction of a customer to Transfer Gold / Silver from his /
                                her Gold / Silver / Silver account to another Gold / Silver account;
                            </li>
                            <li className="mt-4">
                                The exercise by MMTC-PAMP of its right to terminate / exercise the
                                facility / services provided on the Partner Platform;
                            </li>
                            <li className="mt-4">
                                Any injury to the credit, character and reputation of the Customer
                                due to use of facility / services on the Partner Platform;
                            </li>
                            <li className="mt-4">
                                Any misstatement, misrepresentation, error or omission in any
                                details disclosed by MMTC-PAMP if receives any process, summons,
                                order, injunction, execution distrait, levy lien, information or
                                notice which MMTC-PAMP in good faith believes / calls into question
                                the Customer&rsquo;s ability, or the ability of someone purporting
                                to be authorized by the Customer, to make the transfer, MMTC-PAMP
                                may, at its option and without liability to the Customer or such
                                other person, decline to allow the Customer to obtain any portion of
                                his Gold / Silver / product, or may handover such Gold / Silver /
                                product over to an appropriate authority and take any other steps
                                required by applicable law.
                            </li>
                            <li className="mt-4">
                                For any breach of contract / terms / conditions agreed between
                                Customer(s) and Partner Platform and / or between Partner Platform
                                and any third party.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        <strong>Disclaimers and limits of liability:</strong>
                        <ul className="ml-6 list-[lower-alpha] text-neutral-500">
                            <li className="mt-2">
                                The Customer declares it has read, understood and accepted all of
                                the terms and conditions outlined in these Terms. The Customer
                                agrees that when entering into a GAP product transaction with
                                MMTC-PAMP, the Customer is relying on its own judgment and, to the
                                extent permitted by law, and MMTC-PAMP or GAP Partner shall not be
                                liable for any loss or damage caused to the Customer for entering
                                into such GAP product transaction. The Customer acknowledges and
                                declares that any information regarding the GAP including but not
                                limited to the information displayed on the Partner Platform and the
                                Platform, in these Terms, etc., shall not be construed as any advice
                                or recommendation given or views expressed to the Customer, by
                                MMTC-PAMP.
                            </li>
                            <li className="mt-4">
                                MMTC-PAMP does not make any representations, recommendations,
                                projections, warranties or guarantees of any kind, either expressed
                                or implied, including but not limited to the performance of its Gold
                                / Silver / redeemable products with respect to future prices or any
                                return on investment; all warranties of merchantability and fitness
                                for a particular purpose as well as warranties regarding the
                                accuracy, correctness, or completeness of the information, data,
                                content, materials or the services associated with operation of GAP,
                                or the service, or the safety, reliability, title, timeliness,
                                completeness, title, merchantability, conformity or fitness for a
                                particular purpose of the information, data, content, materials or
                                the services associated with the operation of the service. MMTC-PAMP
                                makes no representation, warranty or guarantee that the MMTC-PAMP
                                Platform or its information, data, content, materials, or services
                                is free of infection from any viruses, worms, trojan horses, trap
                                doors, back doors, time bombs, cancel bots or other code or computer
                                programming routines that contain contaminating or destructive
                                properties or that are intended to damage, detrimentally interfere
                                with, surreptitiously intercept or expropriate any system,
                                application, interface, content, data or financial / personal
                                information.
                            </li>
                            <li className="mt-4">
                                GAP and the related service by MMTC-PAMP and pricing and data, and
                                availability are subject at any time and from time to time to human,
                                mechanical, typographic or other errors, oversights, mistakes,
                                limitations, delays, service interruptions, (i) including, without
                                limitation, as may be due in whole or in part to, related to or
                                arising out of MMTC-PAMP&rsquo;s computer hardware and software /
                                platform, telecommunication and operating systems, databases, or
                                business processes and procedures, (ii) as well as other problems
                                inherent in, or which may be associated with, the use of the
                                internet and electronic communications including, without
                                limitation, force majeure events as well as government, regulatory
                                and acts and omissions of third parties affecting or impacting GAP
                                or MMTC-PAMP Services, its information and data, or such
                                communications and MMTC-PAMP shall not be liable for any damages,
                                liabilities, claims, demands, etc. for any loss caused to or
                                suffered by the Customer and MMTC-PAMP disclaims any liability
                                arising due to the same.
                            </li>
                            <li className="mt-4">
                                The GAP is controlled and offered by MMTC-PAMP in India. MMTC-PAMP
                                makes no representations, warranties or guarantees that the GAP is
                                appropriate or available for use in other jurisdictions. If Customer
                                accesses or uses the GAP or MMTC-PAMP&rsquo;s Service from other
                                jurisdictions, then Customer does so by Customer&rsquo;s own
                                volition and Customer is solely responsible for compliance with
                                local law.
                            </li>
                            <li className="mt-4">
                                MMTC-PAMP reserves the right at any time and without notice, in
                                MMTC-PAMP&rsquo;s sole and absolute discretion, to have the GAP
                                hosted by or through one or more other entities and / or in one or
                                more other jurisdictions, provided there shall be no material
                                deterioration in the level of performance of GAP. Subject to the
                                foregoing, the terms and conditions upon which MMTC-PAMP may offer a
                                hosted service, shall be in MMTC-PAMP&rsquo;s sole and absolute
                                discretion, save and except expressly agreed herein.
                            </li>
                            <li className="mt-4">
                                MMTC-PAMP shall not be liable for Customer&rsquo;s failure to follow
                                MMTC-PAMP&rsquo;s reasonable instructions in connection with the GAP
                                and transactions or for the Customer&rsquo;s incorrect use or misuse
                                of GAP. Similarly, GAP Partner shall not be liable for
                                Customer&rsquo;s failure to follow GAP Partner&rsquo;s terms of use
                                or any instructions available on the Partner Platform or for
                                Customer&rsquo;s incorrect use or misuse of the Platform.
                                Notwithstanding anything in these Terms to the contrary, MMTC-PAMP
                                and/or GAP Partner does not and shall not have or bear any
                                responsibility or liability to the Customer(s) with respect to
                                transaction or transaction quotations, orders, acceptances,
                                confirmations, statements of account, or payments.
                            </li>
                            <li className="mt-4">
                                MMTC-PAMP will not be liable for any Loss or damage caused by
                                reliance on information obtained in any of our newsletters,
                                literature, reports, e-mail correspondence, website, or any other
                                communication from MMTC-PAMP. MMTC-PAMP will not be liable to any
                                Customer (including but not limited to transferee) for any Losses
                                caused by or relating to Transfer / deposit of Gold / Silver /
                                Silver-to-Gold / Silver account of any other Customer.
                            </li>
                            <li className="mt-4">
                                MMTC-PAMP explicitly urges to all its Customers to inspect the
                                package for any damage or tamper before receiving or signing for
                                receipt. If you find any tampering, do not accept the parcel and
                                return the same. MMTC-PAMP will not be liable for any loss or damage
                                caused if the Customer accepts the parcel in spite of it being
                                damaged or tampered. The duty to verify the parcel for any damages
                                or tampering is of the Customer and if the Customer accepts the
                                parcel and later comes to know of any damage or tampering, MMTC-PAMP
                                shall not be liable for any loss or damage to Customer. If such loss
                                is later reported and approved by logistics partner and Insurance
                                Company, the limit of liability shall be restricted to the amount
                                paid by the logistic partner for such loss or damage in transit as
                                per their terms and conditions and the same shall be binding upon
                                the Customer.
                            </li>
                            <li className="mt-4">
                                The Customer understands and acknowledges that MMTC-PAMP and/or GAP
                                Partner, or any of its respective directors, employees, agents,
                                shall not be liable for any damages, liabilities, claims, demands,
                                etc. by Customer(s) or any loss caused to or suffered by the
                                Customer, for any reason whatsoever. Causes of action under these
                                Terms and the facility / services provided by MMTC-PAMP save and
                                except loss caused to the Customer due to quality or merchantability
                                of product or redeemed product sold by MMTC-PAMP. In any case, the
                                liability shall not collectively exceed total amount paid by you, if
                                any, for the particular transaction in question. The foregoing
                                limitation of liability shall apply to the fullest extent permitted
                                by law in the applicable jurisdiction.
                            </li>
                            <li className="mt-4">
                                No claim of whatsoever nature arising out of or relating to the use
                                of the Partner Platform and/or any action/omission by Partner, or
                                any of its Retailers, agents, employees, subcontractors,
                                distributors etc. shall lie against MMTC-PAMP.
                            </li>
                        </ul>
                    </li>
                    <li className="mt-4">
                        You acknowledge that MMTC-PAMP will not be liable to you or any other person
                        as a result of your access or use of Gold / Silver / redeemable product for
                        indirect, consequential, special, incidental, punitive, or exemplary
                        damages, including, without limitation, lost profits, lost savings and lost
                        revenues (collectively, the &quot;excluded damages&quot;), whether or not
                        characterized in negligence, tort, contract, or other theory of liability,
                        even if MMTC-PAMP has been advised of the possibility of or could have
                        foreseen any of the excluded damages, and irrespective of any failure of an
                        essential purpose of a limited remedy. You declare that you are an
                        individual not having registration and neither required to take registration
                        under Central Goods and Service Tax Act 2017, State Goods and Service Tax
                        Act 2017, Integrated Goods and Service Tax Act 2017 and Union Territory
                        Goods and Service Tax Act 2017.
                    </li>
                    <li className="mt-4">
                        You declare that you are not an unregistered dealer of Gold / Silver or any
                        other precious metal ornament or any related product.
                    </li>
                    <li className="mt-4">
                        If found of any misrepresentation then you will be solely responsible for
                        all applicable taxes, interest and penalty due to the government at any
                        given point of time.
                    </li>
                    <li className="mt-4">
                        The Customer agrees that they shall peruse and comply with the terms of use
                        as available on the Partner Platform as notified by them from time to time;
                        and the Customer shall be governed by those terms in addition to the terms
                        as contained herein.
                    </li>
                </ul>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Keep SIP Running - Daily Lottery
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is applicable only to registered users of InCred Money who
                            have an active SIP (Systematic Investment Plan) running on the platform
                            during the campaign period.
                        </li>
                        <li className="mb-1">
                            Participants become eligible for the lottery if they have made a SIP
                            payment on the previous day. The more SIP payments completed, the higher
                            the chances of winning in the draw
                        </li>
                        <li className="mb-1">
                            The offer is valid for users who have completed at least one successful
                            SIP transaction during the offer period.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The “Keep SIP Running – Daily Lottery” offer starts from 13th Oct 2025.
                        </li>
                        <li className="mb-1">
                            InCred Money reserves the right to modify or withdraw the offer at any
                            time without prior notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Daily Lottery</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users who continue their active SIPs during the offer period will
                            automatically be enrolled in the daily lottery.
                        </li>
                        <li className="mb-1">
                            Each successful SIP transaction during the offer period counts as one
                            entry for that day’s draw.
                        </li>
                        <li className="mb-1">
                            Winners will be selected through a random draw conducted by InCred Money
                            or its authorized partner.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Daily winners will receive a reward of up to <b>₹10,000</b>, which may
                            be distributed among multiple winners.
                        </li>
                        <li className="mb-1">
                            Users with multiple SIPs may receive rewards for more than one SIP and
                            stays eligible for all.
                        </li>
                        <li className="mb-1">
                            The reward amount and mode of disbursement (cashback, voucher, or
                            equivalent) will be communicated by InCred Money.
                        </li>
                        <li className="mb-1">
                            Rewards are non-transferable and cannot be exchanged for cash.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">
                    Winner Announcement & Communication
                </p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money’s decision regarding winner selection and reward
                            disbursement will be final and binding.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General Conditions</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users must ensure that their SIPs remain active and uninterrupted during
                            the offer period.
                        </li>
                        <li className="mb-1">
                            Any SIP cancellation, failure, or missed installment during the offer
                            period may disqualify the user from the daily draw.
                        </li>
                        <li className="mb-1">
                            InCred Money reserves the right to verify participant eligibility and
                            disqualify entries that do not meet the offer criteria.
                        </li>
                        <li className="mb-1">
                            This offer cannot be combined with any other ongoing promotion, unless
                            explicitly stated.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disclaimer</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money reserves the right to amend these terms and conditions or
                            terminate the offer at its discretion.
                        </li>
                    </ul>
                </div>
                <div className="mb-12">
                    <p className="text-neutral-500">
                        All standard Terms & Conditions of Digital Gold and Digital Silver purchases
                        apply.
                    </p>
                </div>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Dhanteras 1.5% Bonus on Digital Gold & Silver
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is valid only for{" "}
                            <b>first-time Digital Gold & Silver transactions</b> on InCred Money.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is valid only on <b>18th October 2025</b>. Transactions
                            completed outside this date will not be eligible.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Minimum Investment</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users must save <b>₹10,000 or more</b> in a single transaction to be
                            eligible for the bonus.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligible users will receive a <b>1.5% bonus</b> on their invested
                            amount, credited as Digital Gold or Silver in 2 working days.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Limit</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is limited to <b>one account per user</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Redemption</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Bonus Digital Gold or Silver can be <b>redeemed or used for purchase</b>{" "}
                            as per the platform’s standard terms.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disqualification</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money reserves the right to <b>disqualify users</b> who violate
                            these terms, use fraudulent accounts, or attempt multiple sign-ups.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Modification & Termination</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money reserves the right to{" "}
                            <b>modify, suspend, or terminate the offer</b> at any time without prior
                            notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            By participating, users agree to these terms and InCred Money’s{" "}
                            <b>general terms and conditions</b>.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Dhanteras ₹11 Free Digital Gold Sign-Up Offer
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is valid only for <b>first-time sign-ups</b> on the InCred
                            Money App.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is valid only on <b>18th October 2025</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            To receive <b>₹11 worth of Digital Gold</b> - the sign up user needs to
                            do a <b>transaction of ₹12 or more</b> and select the <b>DHANTERAS11</b>{" "}
                            code at checkout. You can sign up and claim this free digital gold only
                            till <b>31st Oct 2025</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Limit</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is limited to <b>one account per user</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Redemption</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Digital Gold credited under this offer can be used for{" "}
                            <b>purchase or redemption</b> as per the platform’s standard Digital
                            Gold terms.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disqualification</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money reserves the right to <b>disqualify users</b> who violate
                            these terms, use fraudulent accounts, or attempt multiple sign-ups.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Modification & Termination</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            InCred Money reserves the right to{" "}
                            <b>modify, suspend, or terminate the offer</b> at any time without prior
                            notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            By participating, users agree to these terms and InCred Money’s{" "}
                            <b>general terms and conditions</b>.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mb-4">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold md:text-6xl">
                    Refunds
                </h3>
                <p className="font-semibold text-black">
                    All refunds will be processed within 7 working days. For any queries, please
                    write to{" "}
                    <a href={"mailto:" + ICM_MAIL_SUPPORT} className="text-blue-500 underline">
                        {ICM_MAIL_SUPPORT}
                    </a>
                    .
                </p>
            </div>

            <div className="mb-4">
                <h3 className="mb-4 text-2xl font-semibold">
                    Terms & Conditions for New Customer Offer
                </h3>
                <ul className="ml-6 list-disc text-neutral-500">
                    <li>
                        Customers are eligible to avail Offer benefit of {ICM_REFER_BENEFIT}% extra
                        returns on their 1st investment only if they have successfully verified
                        their KYC within 7 days of Sign Up. Please Note: The Offer benefit expires
                        after 30 days from successful KYC verification.
                    </li>
                    <li>The Offer benefit is applicable for IPO Investments.</li>
                    <li>
                        For customers with existing investments, the above offer benefit on their
                        First investment of ₹50k or MLD.
                    </li>
                    <li>
                        The offer is not applicable for Special Sure Deals like Diwali, Holi etc.
                    </li>
                </ul>
            </div>

            <div className="mb-12">
                <h3 className="mb-4 text-2xl font-semibold">
                    Consent to receive marketing & transactional communications
                </h3>
                <p className="text-neutral-500">
                    Registered users confirm & acknowledge that by registering on our apps and
                    website, they give consent to InCred Money for sending promotional, marketing &
                    transactional communications to them regularly through email, whatsapp, sms,
                    phone call, and no such communication shall be deemed to be in violation of law.
                </p>
            </div>            
            
            <div className="mb-4">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold md:text-6xl">
                    Terms & Conditions - Gmail Auto-read and Email Data Access
                </h3>
            </div>

            <div className="mb-4">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold md:text-6xl">
                    Terms & Conditions - Gmail Auto-read and Email Data Access
                </h3>
            </div>

            <div className="mb-4">
                <h3 className="mb-4 text-2xl font-semibold">
                    Consent and Authorization
                </h3>
                <p className="text-neutral-500">
                    By enabling the &quot;Gmail Auto-read&quot; feature, you provide your explicit consent for InCred Money to securely connect to your designated Gmail account.
                </p>
            </div>

            <div className="mb-12">
                <h3 className="mb-4 text-2xl font-semibold">
                    Scope of Access
                </h3>
                <p className="text-neutral-500">
                    This access is strictly &quot;read-only&quot; and is functionally limited to identifying and processing emails received specifically from depositories (such as NSDL and CDSL) and registered stock brokers. We do not scan, read, or extract data from your personal, non-financial emails.
                </p>
            </div>

            <div className="mb-12">
                <h3 className="mb-4 text-2xl font-semibold">
                    Purpose of Data Collection
                </h3>
                <p className="text-neutral-500">
                    The sole purpose of this synchronization is to automate the retrieval of your financial documents—specifically, your Consolidated Account Statements (CAS) and Contract Notes. This data allows us to automatically consolidate your stock portfolio, analyze your trading history, and calculate brokerage charges paid, thereby providing you with investment insights and cost-saving estimates.
                </p>
            </div>

            <div className="mb-12">
                <h3 className="tracking--0.48px md-4xl mb-4 font-semibold md:text-6xl">
                    Terms and Conditions
                </h3>
                <p className="mb-4 text-neutral-500">
                    This document is an electronic record in terms of Information Technology Act,
                    2000 and rules made there under as applicable and the amended provisions
                    pertaining to electronic records in various statutes as amended by the
                    Information Technology Act, 2000. This electronic record is generated by a
                    computer system and does not require any physical or digital signatures. This
                    document is published in accordance with the provisions of Rule 3 (1) of the
                    Information Technology (Intermediaries guidelines) Rules, 2011 that require
                    publishing the rules and regulations, privacy policy and Terms and Conditions
                    for access or usage of www.incredmoney.com website or its iOS and android
                    applications.
                </p>
                <p className="mb-4 text-neutral-500">
                    The domain name &lsquo;www.incredmoney.com&rsquo; (hereinafter referred to as
                    &quot;Website&quot; or &quot;the Site&quot;) is owned and operated by ETA
                    Fintech Pvt Limited and/or its subsidiaries (&quot;Company&quot;, &quot;InCred
                    Money&quot;, &quot;we&quot;, &quot;us&quot;, &quot;InCred Money&quot;). Your
                    access to the Site is subject to the terms, conditions and disclaimers appearing
                    on the Site (&quot;Terms and Conditions&quot;), and all applicable laws. By
                    accessing, browsing and/or using the Site, you accept, without limitation or
                    qualification, the Terms and Conditions, which together with our privacy policy
                    and any other applicable policies which are incorporated herein by way of
                    reference or available by hyperlink on the Site, shall govern InCred
                    Money&rsquo;s relationship with you in relation to this Site. Accessing InCred
                    Money on its online technology platform through any medium, including but not
                    limited to the website, on mobile phones and such other devices, is also subject
                    to these Terms &amp; Conditions. These Terms &amp; Conditions supersede all
                    previous oral and written terms and conditions (if any) communicated to you and
                    shall act as an Agreement between InCred Money and users.
                </p>
                <p className="mb-4 text-neutral-500">
                    Minimum Age: You must be 18 years of age or older to use the Site. It is not
                    intended for those under the age of 18. You represent and warrant that you are
                    18 years of age or older and are fully able and competent to enter into, and
                    abide by, the contract created by the Terms and Conditions.
                </p>
                <p className="mb-4 text-neutral-500">
                    Terms and Conditions Cover All Users: By using the Site, you agree to be bound
                    by the Terms and Conditions, whether you are a &quot;visitor&quot; (which means
                    that you simply browse the Site) or you are a &quot;registered user&quot; (which
                    means that you have an Investment Account with the Site to avail the Services or
                    any part thereof, as provided on the Site). Each time you use the Site, the
                    current version of the Terms and Conditions will apply. Accordingly, when you
                    use the Site, you should check and review any changes since the last version.
                    Please review carefully all of the Site&apos;s Terms and Conditions before
                    agreeing to them and accessing the Site by reading through all of the sections
                    appearing below and reviewing all of the linked Terms and Conditions:
                </p>
                <p className="mb-4 text-lg font-semibold text-black">1.Definitions</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            &quot;AMC&quot; shall mean and include Asset Management Company.
                        </li>
                        <li className="mb-1">
                            &quot;InCred Money&quot; or &quot;us&quot; or &quot;we&quot; or
                            &quot;our&quot; or &quot;InCred Money&quot; or &quot;Company&quot; shall
                            mean and refer to Alpha Fintech Pvt Ltd. and its subsidiaries
                        </li>
                        <li className="mb-1">
                            &quot;Use&quot; or &quot;Using&quot; means to browse, access, view,
                            copy, availing Services or other benefit from using the Site;
                        </li>
                        <li className="mb-1">
                            Group Entities - Shall mean affiliates, holding and subsidiaries of
                            Alpha Fintech Private Limited.
                        </li>
                        <li className="mb-1">
                            &quot;Services&quot; means the service of access to the distribution
                            network of InCred Money through its online technology platform for the
                            purchase, switch and redemptions of units of mutual funds listed on the
                            InCred Money Website by users, on the terms and conditions as mentioned.
                        </li>
                        <li className="mb-1">
                            &quot;Force Majeure Event&quot; means any event due to any cause beyond
                            the reasonable control of InCred Money, including without limitations,
                            unavailability of any communication systems, breach, or virus in the
                            processes or payment or delivery mechanism, sabotage, fire, flood,
                            explosion, acts of god, civil commotion, strikes or industrial action of
                            any kind, riots, insurrection, war, acts of government, computer
                            hacking, unauthorised access to computer data and storage devices,
                            computer crashes, malfunctioning in the computer terminal or the systems
                            getting affected by any malicious, destructive or corrupting code or
                            program, mechanical or technical errors/failures or power shut down,
                            faults or failures in telecommunication etc.
                        </li>
                        <li className="mb-1">
                            &quot;The Site&quot; or &quot;Website&quot; or &quot;InCred Money
                            Website&quot; means www.incredmoney.com which includes, any other
                            platform where the Site can be accessed from on mobile phones and such
                            other devices, like, mobile application (whether or not on android or
                            IOS) or any other platform as provided by InCred Money.
                        </li>
                        <li className="mb-1">
                            &quot;Registered User/Registered user/ registered user&quot; shall mean
                            and include the visitors who have Investment Account with the Site to
                            avail the Services or any part thereof, as provided on the Site.
                        </li>
                        <li className="mb-1">
                            &quot;SIP&quot; shall mean Systematic Investment Plans.
                        </li>
                        <li className="mb-1">&quot;NAV&quot; shall mean Net Asset Value.</li>
                        <li className="mb-1">
                            &quot;Account&quot; shall mean the account opened with InCred Money by
                            registered users, for use of the Site or making investment through the
                            Site.
                        </li>
                        <li className="mb-1">
                            &quot;Vendors&quot; shall mean all third-party service providers
                            employed by either InCred Money or AMCs to deliver Services to users.
                            Such vendors include, but are not limited to payment gateway provider,
                            web-based transactions aggregator etc. Website Use User acknowledges
                            that in accessing and using the Services offered by InCred Money, user
                            may utilize the content and Services offered on the InCred Money
                            website. User agrees to follow the terms and conditions for the use of
                            InCred Money website as may be specified on the Site from time to time.
                            Notwithstanding such acceptance of the InCred Money website Terms, user
                            acknowledges and agrees to the following, that:
                        </li>
                        <li>
                            User Account will be activated after InCred Money completes the
                            verification process on the personal information provided at the time of
                            enrolment and in accordance with the.
                        </li>
                    </ol>
                    <ul className="ml-6 list-disc text-neutral-500">
                        <li>
                            Know Your Client (&quot;KYC&quot;) guidelines issued by the Securities
                            and Exchange Board of India (&quot;SEBI&quot;).
                        </li>
                        <li>
                            Common Account Number (&quot;CAN&quot;) requirements as prescribed by
                            AMCs and/or their vendors.
                        </li>
                    </ul>
                </div>
                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            User shall not to copy, reproduce, sell, redistribute, publish, enter
                            into a database, display, perform, modify, transmit, license, create
                            derivatives from, transfer or in any way exploit any part of any
                            information, content, materials, services available from or through the
                            Site, except that which user may download for personal, non‐commercial
                            use.
                        </li>
                        <li className="mb-1">
                            User will not use the Site for any purpose that is unlawful, or
                            prohibited by these Terms. User also agree that user will not use the
                            Site in any manner that could damage, disable or impair the Site or
                            interfere with any other person&rsquo;s use or enjoyment of InCred Money
                            website.
                        </li>
                        <li className="mb-1">
                            The software and hardware underlying the Site as well as other internet
                            related software which are required for accessing the Site are the legal
                            property of the respective vendors. The permission given by InCred Money
                            to access the Websites will not convey any proprietary or ownership
                            rights in the above software/ hardware. User agree that User shall not
                            attempt to modify, translate, disassemble, decompile or reverse engineer
                            the software/hardware underlying the Site or create any derivative
                            product based on the software / hardware.
                        </li>
                        <li className="mb-1">
                            The data and information provided on the Site does not constitute advice
                            and shall not be relied upon by the user while making investment
                            decisions.
                        </li>
                        <li className="mb-1">
                            InCred Money does not, and is not obliged to, offer all mutual fund
                            schemes for investment. By limiting the number of schemes on the Site,
                            InCred Money does not make any representation as to the quality, bona
                            fides or nature of any AMC or mutual fund scheme, or any other
                            representation, warranty or guaranty, express or implied.
                        </li>
                        <li className="mb-1">
                            User agrees that the information and assistance provided on the InCred
                            Money website are true to the knowledge of InCred Money and should not
                            be construed as investment advice, and that InCred Money shall have no
                            liability for any discrepancy in any such information or assistance.
                        </li>
                        <li className="mb-1">
                            InCred Money is not responsible for the availability of content or other
                            services on third party sites linked from the InCred Money website. User
                            agrees and is aware that access of hyperlinks to other internet sites
                            are at user&rsquo;s own risk and the content, accuracy, opinions
                            expressed, and other links provided by these sites are not verified,
                            monitored or endorsed by InCred Money in any way. InCred Money does not
                            make any warranties and expressly disclaims all warranties express or
                            implied, including without limitation, those of merchantability and
                            fitness for a particular purpose, title or non‐ infringement with
                            respect to any information or services or products that are available or
                            advertised or sold through these third party websites.
                        </li>
                        <li className="mb-1">
                            InCred Money has the absolute discretion to amend or supplement any of
                            the InCred Money website Terms at any time without prior notice for such
                            changes. Any such amendment shall be effective immediately. It shall be
                            User&rsquo;s responsibility to review these Terms and Conditions
                            periodically for any updates/changes.
                        </li>
                        <li className="mb-1">
                            An account may be created offline, without accessing the InCred Money
                            website. In the event User creates an investment account offline, user
                            understands and acknowledges that these Terms and Conditions for use of
                            the InCred Money website will continue to be applicable to user for the
                            use of the Services.
                        </li>
                        <li className="mb-1">
                            Mere use of the Website, shall be construed as your intent to contract
                            with us and shall constitute your binding obligations, with us.
                        </li>
                        <li className="mb-1">
                            User understands that it is user&rsquo;s responsibility to check the
                            InCred Money website Terms carefully before accessing or using or
                            transacting on our website.
                        </li>
                        <li className="mb-1">
                            As long as User complies with these Terms and Conditions, we grant user
                            a personal, non-exclusive, non-transferable, limited privilege to enter
                            and use the Site. User acknowledges and understands that use of the Site
                            shall be at your own risk and has the discretion of not using the Site.
                        </li>
                        <li>
                            InCred Money shall not be liable if any transaction does not fructify or
                            may not be completed or for any failure on part of the InCred Money to
                            perform any of its obligations under these terms and conditions or those
                            applicable specifically to its services/facilities if performance is
                            prevented, hindered or delayed by a Force Majeure event and in such case
                            its obligations shall be suspended for so long as the Force Majeure
                            event continues.
                        </li>
                        <li>
                            All information, content, materials, products (including, but not
                            limited to text, content, photographs, graphics, video and audio
                            content) on the InCred Money website is protected by copyright in the
                            favour of InCred Money under applicable copyright laws and is also
                            protected otherwise under general intellectual property law.
                        </li>
                        <li>
                            All information submitted by user to InCred Money whether through the
                            InCred Money website or otherwise shall be deemed to be the property of
                            InCred Money, and InCred Money shall be free to use any ideas, concepts,
                            know‐how or techniques provided by such users at the InCred Money
                            website, in any manner whatsoever.
                        </li>
                        <li>
                            Not all the products and services offered on InCred Money&rsquo;s
                            website are available in all geographic areas and user may not be
                            eligible for all the products or services offered by InCred Money on the
                            Site. InCred Money reserves the right to determine the availability and
                            eligibility for any product or service.
                        </li>
                    </ol>
                </div>
            </div>
        </section>
    );
};

export default TermsAndConditions;
